import type { NumberFieldProps } from '@launchpad-ui/components';
import { Group, IconButton, Input, Label, NumberField as LaunchpadNumberField, Text } from '@launchpad-ui/components';

import { useFieldContext } from '../../contexts';

import { FormFieldError } from './FormFieldError';
import {
  type BrowserExtensionControlProps,
  getDisableBrowserExtensionAttributes,
} from './getDisableBrowserExtensionAttributes';

interface FormNumberFieldProps extends NumberFieldProps, BrowserExtensionControlProps {
  label?: string;
  description?: string;
  showIncrementDecrementButtons?: boolean;
}
export function NumberField({
  label,
  description,
  showIncrementDecrementButtons,
  disableBrowserExtensions = true,
  ...props
}: FormNumberFieldProps) {
  const field = useFieldContext<number>();
  const isInvalid = field.state.meta.isTouched && field.state.meta.isDirty && field.state.meta.errors.length > 0;

  return (
    <LaunchpadNumberField
      name={field.name}
      isInvalid={isInvalid}
      value={field.state.value}
      onChange={(val: number) => {
        field.handleChange(val);
      }}
      onBlur={() => {
        field.handleBlur();
      }}
      {...props}
    >
      {label && <Label>{label}</Label>}
      {description && <Text slot="description">{description}</Text>}
      <Group>
        <Input {...getDisableBrowserExtensionAttributes(disableBrowserExtensions)} />
        {showIncrementDecrementButtons && (
          <>
            <IconButton
              aria-label="decrement"
              icon="minus"
              size="small"
              slot="decrement"
              variant="minimal"
              data-test-id="number-field-decrement"
            />
            <IconButton
              aria-label="increment"
              icon="add"
              size="small"
              slot="increment"
              variant="minimal"
              data-test-id="number-field-increment"
            />
          </>
        )}
      </Group>
      <FormFieldError meta={field.state.meta} />
    </LaunchpadNumberField>
  );
}
